// ie polyfill
import '@babel/polyfill'
import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store/'
import { VueAxios } from '@/utils/request'
import vRometeJs from 'v-remote-js'
import bootstrap from '@/core/bootstrap'
import lineClamp from 'vue-line-clamp'
import LineClamp from 'v-line-clamp';

// 引入moment，用于格式化ant的日期选择器的值
import moment from "moment";

import '@/core/use'
import '@/permission' // permission control
import '@/utils/filter' // global filter
import '@/utils/websocket' // global websocket

Vue.config.productionTip = false

// 全局注册一下这个moment
Vue.prototype.$moment = moment;


// RometeJs
Vue.use(vRometeJs)
// mount axios Vue.$http and this.$http
Vue.use(VueAxios)
// vue-line-clamp
Vue.use(lineClamp, {
  // plugin options
})
Vue.use(LineClamp)
new Vue({
  router,
  store,
  created () {
    bootstrap()
  },
  render: h => h(App)
}).$mount('#app')
